import { Record } from "immutable";
import moment from "moment";

const defaults = {
    available: 0,
    display_quantity: "",
    for_date: undefined,
    sku_id: undefined,
};

export class Inventory extends Record(defaults) {
    declare available: number;
    declare display_quantity: string;
    declare for_date: moment.Moment;
    declare sku_id: string;

    constructor(args) {
        super({
            ...args,
            for_date: moment.utc(args.for_date),
        });
    }

    isValidQuantity(quantity: number, canOversell = false) {
        const isPositiveNumber = !isNaN(quantity) && Number(quantity) >= 0;
        if (canOversell) {
            return isPositiveNumber;
        } else {
            return isPositiveNumber && this.available >= quantity;
        }
    }
}
